function getCartDrawerRoutes() {
  const routes = window.routes || {};
  const root = (window.Shopify?.routes?.root || "/").replace(/\/?$/, "/");

  const addUrl = routes.cart_add_url || `${root}cart/add`;
  const changeUrl = routes.cart_change_url || `${root}cart/change`;
  const cartUrl = routes.cart_url || `${root}cart`;

  return {
    cartAddJs: addUrl.endsWith(".js") ? addUrl : `${addUrl}.js`,
    cartChangeJs: changeUrl.endsWith(".js") ? changeUrl : `${changeUrl}.js`,
    cartJs: cartUrl.endsWith(".js") ? cartUrl : `${cartUrl}.js`,
    cartUrl: cartUrl.replace(/\.js$/, ""),
  };
}

function refreshCartDrawer(source) {
  if (typeof publish === "function" && typeof PUB_SUB_EVENTS !== "undefined") {
    publish(PUB_SUB_EVENTS.cartUpdate, { source: source || "cart-drawer-protection" });
    return;
  }

  document.querySelector("cart-drawer-items")?.onCartUpdate?.();
}

function getProtectionVariantId() {
  const protectionEl = document.querySelector("cart-drawer-shipping-protection");
  if (protectionEl?.dataset.variantId) return protectionEl.dataset.variantId;

  const drawer = document.querySelector("cart-drawer.cart-drawer-aov");
  return drawer?.dataset.protectionVariantId || null;
}

let orphanProtectionCleanupTimer = null;

function queueOrphanProtectionCleanup() {
  clearTimeout(orphanProtectionCleanupTimer);
  orphanProtectionCleanupTimer = setTimeout(() => {
    removeOrphanShippingProtection();
  }, 150);
}

function removeOrphanShippingProtection() {
  const variantId = getProtectionVariantId();
  if (!variantId) return;

  const routes = getCartDrawerRoutes();

  return fetch(routes.cartJs)
    .then((response) => response.json())
    .then((cart) => {
      const nonProtectionItems = cart.items.filter(
        (item) => String(item.variant_id) !== String(variantId)
      );
      const protectionItems = cart.items.filter(
        (item) => String(item.variant_id) === String(variantId)
      );

      if (protectionItems.length === 0 || nonProtectionItems.length > 0) return;

      const line =
        cart.items.findIndex(
          (item) => String(item.variant_id) === String(variantId)
        ) + 1;

      if (!line) return;

      return fetch(routes.cartChangeJs, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({ line, quantity: 0 }),
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.status || data.description) {
            console.error(
              "[Shipping protection cleanup]",
              data.description || data.message
            );
            return;
          }
          refreshCartDrawer("orphan-protection-cleanup");
        });
    })
    .catch((error) => console.error("[Shipping protection cleanup]", error));
}

function initShippingProtectionCleanup() {
  if (typeof subscribe !== "function" || typeof PUB_SUB_EVENTS === "undefined") {
    return;
  }

  if (initShippingProtectionCleanup.subscribed) return;
  initShippingProtectionCleanup.subscribed = true;

  subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
    if (event?.source === "orphan-protection-cleanup") return;
    queueOrphanProtectionCleanup();
  });
}

function bootShippingProtection() {
  initShippingProtectionCleanup();
  queueOrphanProtectionCleanup();
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", bootShippingProtection);
} else {
  bootShippingProtection();
}

class CartDrawerUpsell extends HTMLElement {
  constructor() {
    super();
    this.boundAddHandler = this.onAdd.bind(this);
  }

  connectedCallback() {
    this.querySelectorAll("[data-cart-drawer-upsell-add]").forEach((button) => {
      button.removeEventListener("click", this.boundAddHandler);
      button.addEventListener("click", this.boundAddHandler);
    });
  }

  onAdd(event) {
    const button = event.currentTarget;
    const variantId = button.dataset.variantId;
    if (!variantId) return;

    const routes = getCartDrawerRoutes();
    button.disabled = true;

    fetch(routes.cartAddJs, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({
        items: [{ id: parseInt(variantId, 10), quantity: 1 }],
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status || data.description) {
          console.error("[Cart drawer upsell]", data.description || data.message);
          return;
        }
        refreshCartDrawer("cart-drawer-upsell");
      })
      .catch((error) => console.error("[Cart drawer upsell]", error))
      .finally(() => {
        button.disabled = false;
      });
  }
}

class CartDrawerShippingProtection extends HTMLElement {
  constructor() {
    super();
    this.onToggleHandler = this.onToggle.bind(this);
  }

  connectedCallback() {
    this.checkbox = this.querySelector(".cart-drawer-aov__protection-input");
    if (!this.checkbox) return;

    this.checkbox.removeEventListener("change", this.onToggleHandler);
    this.checkbox.addEventListener("change", this.onToggleHandler);
  }

  onToggle(event) {
    const checked = event.target.checked;
    const variantId = this.dataset.variantId;

    if (!variantId) {
      event.target.checked = false;
      return;
    }

    this.checkbox.disabled = true;

    if (checked) {
      this.addProtection(variantId);
    } else {
      this.removeProtection(variantId);
    }
  }

  addProtection(variantId) {
    const routes = getCartDrawerRoutes();

    fetch(routes.cartJs)
      .then((response) => response.json())
      .then((cart) => {
        const hasOtherProducts = cart.items.some(
          (item) => String(item.variant_id) !== String(variantId)
        );

        if (!hasOtherProducts) {
          this.checkbox.checked = false;
          return;
        }

        return fetch(routes.cartAddJs, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify({
            items: [{ id: parseInt(variantId, 10), quantity: 1 }],
          }),
        })
          .then((response) => response.json())
          .then((data) => {
            if (data.status || data.description) {
              console.error(
                "[Shipping protection]",
                data.description || data.message
              );
              this.checkbox.checked = false;
              return;
            }
            refreshCartDrawer("cart-drawer-protection");
          });
      })
      .catch((error) => {
        console.error("[Shipping protection]", error);
        this.checkbox.checked = false;
      })
      .finally(() => {
        if (this.checkbox) this.checkbox.disabled = false;
      });
  }

  removeProtection(variantId) {
    const routes = getCartDrawerRoutes();
    const lineIndex = this.dataset.lineIndex;

    if (lineIndex) {
      const cartDrawerItems = document.querySelector("cart-drawer-items");
      if (cartDrawerItems?.updateQuantity) {
        cartDrawerItems.updateQuantity(lineIndex, 0);
        this.checkbox.disabled = false;
        return;
      }
    }

    fetch(routes.cartJs)
      .then((response) => response.json())
      .then((cart) => {
        const itemIndex = cart.items.findIndex(
          (item) => String(item.variant_id) === String(variantId)
        );

        if (itemIndex === -1) {
          this.checkbox.checked = false;
          return;
        }

        const line = itemIndex + 1;

        return fetch(routes.cartChangeJs, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify({ line, quantity: 0 }),
        })
          .then((response) => response.json())
          .then((data) => {
            if (data.status || data.description) {
              console.error("[Shipping protection]", data.description || data.message);
              this.checkbox.checked = true;
              return;
            }
            refreshCartDrawer("cart-drawer-protection");
          });
      })
      .catch((error) => {
        console.error("[Shipping protection]", error);
        this.checkbox.checked = true;
      })
      .finally(() => {
        if (this.checkbox) this.checkbox.disabled = false;
      });
  }
}

if (!customElements.get("cart-drawer-upsell")) {
  customElements.define("cart-drawer-upsell", CartDrawerUpsell);
}

if (!customElements.get("cart-drawer-shipping-protection")) {
  customElements.define(
    "cart-drawer-shipping-protection",
    CartDrawerShippingProtection
  );
}
